import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Controller, useFormContext } from 'react-hook-form';

import { StyleRawTypography } from '../style';

import { StyleCheckboxListItem } from './style';

import { IAnswer, IQuiz } from '@interfaces/learning';
import { sanitize } from 'src/helpers/utils';

export type MultipleChoiceFormProps = {
  content: IQuiz;
  answers: IAnswer[] | null;
  showAnswer?: boolean;
  isLoading?: boolean;
};

export type InteractiveMultipleChoiceFields = {
  answer: number | null;
};

const MultipleChoiceForm = ({ content, answers, showAnswer, isLoading }: MultipleChoiceFormProps) => {
  const questionSet = content.question_sets?.[0];
  const question = questionSet?.question_sets_questions?.[0]?.content!;

  const {
    control,
    formState: { errors, isSubmitted },
  } = useFormContext<InteractiveMultipleChoiceFields>();

  return (
    <>
      <StyleRawTypography fontWeight={500} fontSize={24} mb={3} dangerouslySetInnerHTML={sanitize(question.name)} />
      <Controller
        name="answer"
        control={control}
        render={({ field }) => (
          <>
            {question.answers.map((answer: any) => {
              const checked = field.value === answer.id;
              const result = answers?.find((answerResult) => answerResult.id === answer.id);
              const showError = errors.answer && !result?.is_correct && checked;
              let secondaryAction: React.ReactNode | null;
              if (isSubmitted) {
                if (checked && result?.is_correct) {
                  secondaryAction = <CheckIcon sx={{ display: 'flex', alignItems: 'center' }} color="success" />;
                } else if (showError) {
                  secondaryAction = <ClearIcon sx={{ display: 'flex', alignItems: 'center' }} color="error" />;
                }
              }

              return (
                <StyleCheckboxListItem
                  key={answer.id}
                  hideRadio={showAnswer || (isSubmitted && !isLoading)}
                  checked={checked}
                  readonly={showAnswer || isSubmitted}
                  onChange={(_, selected) => {
                    if (selected) {
                      field.onChange(answer.id);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  secondaryAction={secondaryAction}
                  isSubmitted={isSubmitted}
                  isLoading={isLoading}
                  isCorrect={result?.is_correct}
                  isAnswer={showAnswer && result?.is_correct}
                  isError={showError}
                  value={answer.id}
                >
                  <StyleRawTypography dangerouslySetInnerHTML={sanitize(answer.description)} />
                </StyleCheckboxListItem>
              );
            })}
          </>
        )}
      />
    </>
  );
};

export default MultipleChoiceForm;
